import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
    createstructure,
    deletestructure,
    liststaff,
    liststructure,
    viewstructure,
} from "../../../services/admin";

export default function SalaryStructure() {
    const [slist, setSList] = useState([]);
    const [rows, setRows] = useState([]);

    const [staff, setStaff] = useState("");
    const [basic, setBasic] = useState("");
    const [hra, setHra] = useState("");
    const [bonus, setBonus] = useState("");
    const [pf, setPf] = useState("");
    const [esi, setEsi] = useState("");
    const [pt, setPt] = useState("");
    const [submit, setSubmit] = useState(false);
    const [saveErr, setSaveErr] = useState("");

    const numChange = (setter) => (e) => {
        const regex = /^[0-9\b.]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            setter(e.target.value);
        }
    };

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 120,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a onClick={() => loadStructure(params.data.staff_id)}
                            className="btn-sm btn-info me-2" title="Edit Structure">
                            <i className="fa fa-edit"></i>
                        </a>
                        <a onClick={() => handleDelete(params.value)}
                            className="btn-sm btn-danger me-2" title="Delete Structure">
                            <i className="fa fa-trash"></i>
                        </a>
                    </div>
                );
            },
        },
        { headerName: "Staff Name", field: "staff_name", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Staff Code", field: "staff_code", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Basic", field: "basic", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "HRA", field: "hra", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Bonus", field: "bonus", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "PF", field: "pf", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "ESI", field: "esi", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "PT", field: "pt", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
    ];

    useEffect(() => {
        liststaff(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                setSList(res.data.details);
            }
        });
        funlist();
    }, []);

    function funlist() {
        setRows([]);
        liststructure(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                setRows(res.data.details);
            }
        });
    }

    function reset() {
        setStaff("");
        setBasic("");
        setHra("");
        setBonus("");
        setPf("");
        setEsi("");
        setPt("");
        setSubmit(false);
        setSaveErr("");
    }

    function loadStructure(staffId) {
        setSaveErr("");
        setStaff(staffId);
        viewstructure(staffId).then((res) => {
            if (res.status === true && res.data.details !== null) {
                const d = res.data.details;
                setBasic(d.basic);
                setHra(d.hra);
                setBonus(d.bonus);
                setPf(d.pf);
                setEsi(d.esi);
                setPt(d.pt);
            }
        });
    }

    function handleStaff(e) {
        // Picking a staff loads their existing structure (if any) for editing.
        loadStructure(e.target.value);
    }

    function handleSubmit(e) {
        e.preventDefault();
        setSubmit(true);
        setSaveErr("");
        if (staff === "") {
            return;
        }
        const temp = new FormData();
        temp.append("staff_id", staff);
        temp.append("basic", basic === "" ? 0 : basic);
        temp.append("hra", hra === "" ? 0 : hra);
        temp.append("bonus", bonus === "" ? 0 : bonus);
        temp.append("pf", pf === "" ? 0 : pf);
        temp.append("esi", esi === "" ? 0 : esi);
        temp.append("pt", pt === "" ? 0 : pt);
        createstructure(temp).then((res) => {
            if (res.status === true) {
                reset();
                funlist();
            } else {
                setSaveErr(res.message || "Unable to save salary structure");
            }
        });
    }

    function handleDelete(id) {
        Swal.fire({
            text: "Are you sure want to Delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                deletestructure(id).then((response) => {
                    if (response.status === true) {
                        funlist();
                    }
                });
            }
        });
    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Salary Structure</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a>Payslip</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Salary Structure</li>
                </ol>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">Assign Salary Structure</h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">Staff<span className="text-danger"> *</span></label>
                                            <select className="default-select form-control wide" value={staff} onChange={handleStaff}>
                                                <option value="" disabled>Select Staff</option>
                                                {slist.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.staff_name} ({item.staff_code})
                                                    </option>
                                                ))}
                                            </select>
                                            {submit && staff === "" && (
                                                <span className="text-danger">Please Select Staff</span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">Basic</label>
                                            <input type="text" className="form-control" placeholder="Enter Basic" value={basic} onChange={numChange(setBasic)} />
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">HRA</label>
                                            <input type="text" className="form-control" placeholder="Enter HRA" value={hra} onChange={numChange(setHra)} />
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">Advance towards statutory Bonus</label>
                                            <input type="text" className="form-control" placeholder="Enter Bonus" value={bonus} onChange={numChange(setBonus)} />
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">PF</label>
                                            <input type="text" className="form-control" placeholder="Enter PF" value={pf} onChange={numChange(setPf)} />
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">ESI</label>
                                            <input type="text" className="form-control" placeholder="Enter ESI" value={esi} onChange={numChange(setEsi)} />
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">PT</label>
                                            <input type="text" className="form-control" placeholder="Enter PT" value={pt} onChange={numChange(setPt)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="text-right">
                                    <a className="btn btn-success me-2" onClick={handleSubmit}>Save</a>
                                    <a className="btn btn-secondary" onClick={reset}>Clear</a>
                                    {saveErr !== "" && <div className="text-danger mt-2">{saveErr}</div>}
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">Salary Structure List</h2>
                            </div>
                            <div className="card-body">
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={rows}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
